<select #field
        class="form-control"
        [ngModel]="innerValue"
        (ngModelChange)="writeValue($event)"
        (blur)="onTouched()">
  <option [ngValue]="undefined"></option>
  <option [ngValue]="'true'">Yes</option>
  <option [ngValue]="'false'">No</option>
</select>
